<template>
  <div id="network-container">
    <div id="network"></div>
    <div id="network-overlay" class="column">
      <div class="overlay-content">
        <div id="close-overlay">Cerrar</div>
        <div id="overlay-body"></div>
      </div>
    </div>
  </div>
</template>

<script>
import vis from 'vis'

window.NETWORK = null

export default {
  props: ['character', 'network'],
  data () {
    return {
      nodes: [],
      edges: [],
      options: {
        interaction: {
          navigationButtons: true
        },
        nodes: {
          mass: 1,
          borderWidth: 0,
          font: {
            size: 8
          },
          scaling: {
            min: 5,
            max: 15
          }
        },
        edges: {
          arrows: {
            to: { enabled: true, scaleFactor: 0.5, type: 'arrow' }
          },
          font: {
            align: 'top',
            size: 6
          }
        }
      }
    }
  },
  created () {
    const id = this.character.id
    const edges = this.network.edges.slice().filter(edge => edge.from === id || edge.to === id)
    let ids = edges.reduce((array, edge) => {
      array.push(edge.from, edge.to)
      return array
    }, [])
    ids = [...new Set(ids)]
    const nodes = this.network.nodes.slice().filter(n => ids.includes(n.id))
    this.nodes = nodes
    this.edges = edges
  },
  mounted () {
    const container = document.getElementById('network')
    const data = {
      nodes: new vis.DataSet(this.nodes),
      edges: new vis.DataSet(this.edges)
    }

    if (window.NETWORK) {
      window.NETWORK.destroy()
      window.NETWORK = null
    }

    window.NETWORK = new vis.Network(container, data, this.options)

    const overlay = document.getElementById('network-overlay')
    const close = document.getElementById('close-overlay')

    close.addEventListener('click', () => overlay.classList.remove('upper'))

    window.NETWORK.on('selectNode', (event) => {
      overlay.classList.add('upper')
      const node = this.nodes.find(n => n.id === event.nodes[0])
      const template = `
        <h3>${node.label}</h3>
        ${node.description || ''}
      `
      document.getElementById('overlay-body').innerHTML = template
      window.NETWORK.unselectAll()
    })
  }
}
</script>

<style scoped>
.vis-up,
.vis-down,
.vis-left,
.vis-right {
  display: none !important;
}

#network-container {
  height: 500px;
  position: relative;
}

#network {
  height: 100%;
}

#network-overlay {
  background: rgba(50,50,50,0.98);
  bottom: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.25s linear;
  visibility: hidden;
  z-index: -1;
}

#network-overlay.upper {
  opacity: 1;
  visibility: visible;
  z-index: 10;
}

#close-overlay {
  cursor: pointer;
  font-size: small;
  margin-bottom: 10px;
  text-align: right;
}

.overlay-content {
  color: white;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  padding: 15px;
}

#overlay-body >>> a {
  color: #f52749;
  text-decoration: none;
  transition: all 0.1s;
}

#overlay-body >>> a:hover {
  color: #550f3f;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/Network.vue